import fetch from '../utils/fetch';
import { rosterUrl } from 'endpoints';
const RosterSDK = require( '@nackle/roster-sdk' );
const sdk = new RosterSDK( rosterUrl, fetch );

/*******************************************************************************
 * Initial state
 */
const initialState = {
    attributeTypes: [],
    attributeTypesLoading: false,
    attributeTypesLoaded: false
};

/*******************************************************************************
 * Non-async action types
 */
const SET_STATE = 'roster/setState';

/*******************************************************************************
 * Reducer
 */
export default function rosterReducer( state = initialState, action ) {
    switch ( action.type ) {
        case SET_STATE: {
            return {
                ...state,
                ...action.state
            };
        }

        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
function setState( state ) {
    return {
        type: SET_STATE,
        state
    };
}

function loadAttributeTypes() {
    return async ( dispatch ) => {
        dispatch( setState( { attributeTypesLoading: true } ) );

        let attributeTypes = [];
        try {
            const { attributes } = await sdk.getPersonAttributeTypes();
            attributeTypes = attributes.sort( ( a, b ) => a.name.localeCompare( b.name, 'en', { 'sensitivity': 'base' } ) );
            return attributeTypes;
        } finally {
            dispatch( setState( {
                attributeTypes,
                attributeTypesLoaded: true,
                attributeTypesLoading: false
            } ) );
        }
    };
}

export const actions = {
    loadAttributeTypes
};
